<script>
import PrtfPortfolioApiAdminService from "../../Services/Api/Admin/PrtfPortfolioApi";
import _ from "lodash";
export default {
  name: "TheListsPortfolios",

  data() {
    return {
      listPortfolios: [],
      search: null,
      loading: true,
    };
  },

  async mounted() {
    await this.fetchPortfolios();
    this.loading = false;
  },

  computed: {
    filteredListPortfolios() {
      if(_.isNil(this.search) || _.isEmpty(this.search)) return this.listPortfolios;

      return _.filter(this.listPortfolios, portfolio =>
        _.includes(_.lowerCase(portfolio.full_name), _.lowerCase(this.search))
      );
    },
  },

  methods: {
    async fetchPortfolios() {
      const response = await PrtfPortfolioApiAdminService.index();
      if (_.isNull(response)) return;

      if (!response.data.hasOwnProperty("error")) {
        this.listPortfolios = response.data.portfolios;
      }
    },
  },
}
</script>

<template>

  <v-card elevation="0">
    <template v-if="loading">
      <v-card-text class="d-flex justify-center align-center">
        <v-progress-circular
          :size="70"
          :width="7"
          :color="$store.state.achievement.side_color"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
    </template>

    <template v-else>
      <v-card-text>
        <v-text-field
          v-model="search"
          append-icon="fa fa-search"
          label="Поиск"
          single-line
          hide-details
          outlined
          class="rounded-xl"
          clearable
          dense
          @click:clear="search = ''"
        ></v-text-field>
      </v-card-text>
      <v-card-text>

        <v-virtual-scroll
          :items="filteredListPortfolios"
          :item-height="50"
          height="max(65vh, 500px)"
        >
          <template v-slot:default="{ item }">
            <v-list-item>
              <v-list-item-avatar>
                <v-avatar
                  :color="item.color"
                  size="65"
                  class="white--text"
                >
                  <v-img
                    :src="item.photo.url"
                  >
                  </v-img>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{ item.full_name }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  depressed
                  small
                  @click="$emit('open-portfolio', item)"
                >
                  Просмотр
                  <v-icon
                    color="orange darken-4"
                    right
                  >
                    fa-search
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-card-text>
    </template>
  </v-card>

</template>

<style scoped>

</style>